
import { defineComponent, ref, onBeforeMount, watch, computed } from 'vue';

import { useRoute } from 'vue-router';
import AskusList from './AskusList.vue';
import AskusQuestion from './AskusQuestion.vue';
import AskusNew from './AskusNew.vue';
import VueLoading from '@/components/general/Loading.vue';
import Message from 'primevue/message';

import { askusStore } from '@/store/askus-store';
import { domainStore } from '@/store/domain-store';
import { userStore } from '@/store/user-store';
import { IAskusQuestion } from '@/models/askus.model';
import askusRepository from '@/api/askusRepository';

import useHashParams from '@/composables/general/useHashParams';
import useAuthentication from '@/composables/user/useAuthentication';

export default defineComponent({
  name: 'Askus',
  props: {
    domainid: {
      type: Number,
      required: true,
    },
    askusid: {
      type: Number,
      required: true,
    },
  },
  components: {
    AskusList,
    AskusQuestion,
    AskusNew,
    Message,
    VueLoading,
  },

  setup(props, context) {
    onBeforeMount(() => {
      domainStore.setDomainId(props.domainid);
      askusStore.setAskusId(props.askusid);
    });
    const route = useRoute();
    const errMessage = ref('Sprechstunde konnte nicht gefunden werden.');
    const { getVirtualUser } = useAuthentication();
    const { setHashParams, deleteHashParams } = useHashParams(route);
    const currentComponent = ref({
      name: 'AskusList',
      askusid: props.askusid,
      question: {},
    });
    const askus = computed(() => {
      return askusStore.getState().askus;
    });
    const loadingAskus = computed(() => {
      return askusStore.getState().loadingAskus;
    });
    function openQuestionComponent(question: IAskusQuestion, questionid: number) {
      currentComponent.value.question = question;
      askusStore.fetchAnswer(questionid);
      setHashParams({ question_id: questionid });
      currentComponent.value.name = 'AskusQuestion';
    }
    function openListComponent() {
      currentComponent.value.name = 'AskusList';
      if (route.query.question_id) {
        deleteHashParams(['question_id']);
      }
    }
    watch(route, () => {
      if (
        route.query.question_id &&
        !Array.isArray(route.query.question_id) &&
        !Object.keys(currentComponent.value.question).length
      ) {
        const question_id = parseInt(route.query.question_id);
        currentComponent.value.name = 'AskusQuestion';
        askusRepository.getQuestion(question_id).then((res: any) => {
          currentComponent.value.askusid = res.data.data.askus.id;
          currentComponent.value.question = res.data.data;
          askusStore.fetchAnswer(question_id);
        });
      }
      if (
        (route.query.sort || route.query.textFilter) &&
        (!Array.isArray(route.query.sort) || !Array.isArray(route.query.text)) &&
        !Object.keys(currentComponent.value.question).length
      ) {
        const text = route.query.textFilter ? String(route.query.textFilter) : '';
        const sort = route.query.sort ? String(route.query.sort) : '';
        askusStore.setFilter(sort, text);
        askusStore.fetchQuestions();
      }
    });
    // watch on project in store to setup filter values after project was fetched
    watch(
      () => askusStore.getState().askus,
      (askus, oldaskus) => {
        if (askus !== null && askus.id === props.askusid) {
          errMessage.value = '';
        } else {
          errMessage.value = 'Sprechstunde konnte nicht gefunden werden.';
        }

        if (!userStore.getState().authToken && process.env.VUE_APP_ENABLE_VIRTUAL_USER) {
          // try to init/get virtual user for eventual anonymous votes/comments/thoughts
          getVirtualUser()
            .then(success => {
              console.log('initialized virtual user');
            })
            .catch(e => {
              console.log('error getting virtual user');
            });
        }
      }
    );
    return {
      currentComponent,
      openQuestionComponent,
      openListComponent,
      askus,
      errMessage,
      loadingAskus,
    };
  },
});
